import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Confetti, MapPin, ArrowRight } from "@phosphor-icons/react";

export default function Events() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/events");
      setItems(data);
      setLoading(false);
    })();
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = items.filter(e => e.event_date >= today);
  const past = items.filter(e => e.event_date < today);

  return (
    <div className="pt-20 max-w-5xl mx-auto px-5 lg:px-8 pb-24" data-testid="events-page">
      <div className="mb-10">
        <div className="font-mono-accent text-xs text-[#F59E0B] mb-2">◢ AGENDA</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">Eventos</h1>
        <p className="text-zinc-400 mt-2">Convenções, sessões de autógrafos, encontros e mais.</p>
      </div>

      {loading ? (
        <div className="text-center font-mono-accent text-xs text-zinc-500 py-10">A CARREGAR...</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl py-20 text-center">
          <Confetti size={42} weight="duotone" className="text-[#F59E0B] mx-auto mb-3" />
          <div className="font-display font-bold text-xl">Sem eventos agendados</div>
        </div>
      ) : (
        <>
          {upcoming.length > 0 && (
            <section className="mb-12">
              <div className="font-mono-accent text-xs text-[#F59E0B] mb-4">PRÓXIMOS</div>
              <div className="space-y-4">
                {upcoming.map(e => <EventCard key={e.event_id} event={e} />)}
              </div>
            </section>
          )}
          {past.length > 0 && (
            <section className="opacity-60">
              <div className="font-mono-accent text-xs text-zinc-500 mb-4">PASSADOS</div>
              <div className="space-y-4">
                {past.map(e => <EventCard key={e.event_id} event={e} />)}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
}

function EventCard({ event }) {
  return (
    <Link
      to={`/eventos/${event.event_id}`}
      className="card-hover bg-[#121217] border border-white/5 rounded-2xl overflow-hidden grid md:grid-cols-[220px,1fr] block group"
      data-testid={`event-${event.event_id}`}
    >
      {event.image_url ? (
        <div className="aspect-[16/10] md:aspect-auto md:h-full">
          <img src={event.image_url} alt={event.title} className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="hidden md:grid place-items-center bg-gradient-to-br from-[#F59E0B]/20 to-[#E63946]/20">
          <Confetti size={42} weight="duotone" className="text-[#F59E0B]" />
        </div>
      )}
      <div className="p-6">
        <div className="font-mono-accent text-[10px] text-[#F59E0B] mb-2">
          {new Date(event.event_date).toLocaleDateString("pt-PT", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
        </div>
        <h2 className="font-display font-bold text-2xl tracking-tight group-hover:text-[#F59E0B] transition-colors">{event.title}</h2>
        {event.location && (
          <div className="text-sm text-zinc-400 mt-2 flex items-center gap-1">
            <MapPin size={14} weight="bold" /> {event.location}
          </div>
        )}
        {event.description && <p className="text-zinc-300 mt-3 whitespace-pre-line leading-relaxed line-clamp-3">{event.description}</p>}
        <div className="mt-4 inline-flex items-center gap-1 text-sm text-[#F59E0B] font-medium">
          Ver detalhes <ArrowRight size={14} weight="bold" />
        </div>
      </div>
    </Link>
  );
}
